<template>
  <div>
    <div class="container">
      <!-- 面包屑 -->
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('myInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareRequirementsList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareRequirementsList')">备件需求</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">备件需求维护</div>
      </div>
      <div class="sjz">
        <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
             v-for="(item, index) in steps"
             :key="index">
          <div class="sjz-item">
            <div :class="'sjz-icon '+ ((index>activeIndex)?'sjz-undone':(index===activeIndex)?'sjz-do':'')">
              <i class="el-icon-check"
                 style="width:40px;height:40px;"
                 v-if="index<activeIndex"></i>
              <span class="sjc-num sjc-do"
                    v-else-if="index===activeIndex">{{index+1}}</span>
              <span class="sjc-num"
                    v-else-if="index>activeIndex">{{index+1}}</span>
            </div>
            <div class="sjz-word">{{item.name}}</div>
            <div class="sjz-time">{{item.time}}</div>
          </div>
          <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
               v-if="index!==(steps.length-1)"></div>
        </div>
      </div>
      <div class="body-info">
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 :rules="dataRule"
                 label-width="160px"
                 class="demo-form-inline"
                 v-if="detailInfo">
          <h3 class="spareInfo">基本信息</h3>
          <!-- <el-row>
        <el-col :span="12" v-if="detailInfo">
          <el-form-item label="备件需求状态：" prop="inquiryNo">
            <label>
              <span v-if="detailInfo.status === '0'" style="color: #1D65A8;">需求已提交</span>
              <span v-if="detailInfo.status === '1'" style="color: #1D65A8;">待确认</span>
              <span v-if="detailInfo.status === '2'" style="color: #1D65A8;">客户已确认</span>
              <span v-if="detailInfo.status === '4'" style="color: #1D65A8;">已取消</span>
              <span v-if="detailInfo.status === '5'" style="color: #1D65A8;">已完成</span>
            </label>
          </el-form-item>
        </el-col>
      </el-row> -->
          <el-row class="row-height">
            <el-col :span="12"
                    class="row-height">
              <el-form-item label="公司名称："
                            prop="userMobile">
                <label>{{detailInfo.companyName}}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
                    class="row-height row-margin">
              <el-form-item label="客户负责人："
                            prop="userServiceShopName">
                <label>{{ detailInfo.customerLeaderName }}</label>
              </el-form-item>
            </el-col>
            <el-col :span="12"
                    class="row-height row-margin">
              <el-form-item label="联系电话："
                            prop="userCompany">
                <label>{{ detailInfo.customerLeaderMobile }}</label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
                    class="row-date">
              <el-form-item label="备料期望完成日期："
                            prop="userName">
                <label>
                  <el-date-picker v-model="dataForm.wishEndDate"
                                  type="date"
                                  placeholder="选择日期"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions1"
                                  clearable>
                  </el-date-picker>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备件需求协议：">
                <el-upload ref="upLoadFile"
                           class="upload-demo"
                           :action="actionUrl"
                           :on-remove="handleRemove"
                           :before-remove="removeFile"
                           :auto-upload="true"
                           :on-success="successFile"
                           :on-error="errorFile"
                           :before-upload="beforeUpload"
                           :data="{ fileSuffixType: 'allType' }"
                           :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
                           :limit="10"
                           :on-exceed="handleExceed"
                           :file-list="fileListS">
                  <div slot="trigger"
                       class="uploadPickUp">
                    <i class="el-icon-plus"></i>
                  </div>
                  <div slot="tip"
                       class="el-upload__tip">单个文件大小不能超过100mb,且上传文件个数不超过10个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="">
                <ul v-if="imgList.length > 0"
                    class="inquiryfj">
                  <li class="pointer"
                      v-for="(item, index) in imgList"
                      :key="index">
                    <div class="inquiryfjx removePic"
                         @click.prevent="removeHandle(item, index)">X</div>
                    <div @click="download(item.url)">
                      <img v-if="item.fileType === 'docx'"
                           src="../../../../assets/img/word.png">
                      <img v-else-if="item.fileType === 'doc'"
                           src="../../../../assets/img/word.png">
                      <img v-else-if="item.fileType === 'zip'"
                           src="../../../../assets/img/zip.png">
                      <img v-else-if="item.fileType === 'xls'"
                           src="../../../../assets/img/excel.png">
                      <img v-else-if="item.fileType === 'xlsx'"
                           src="../../../../assets/img/excel.png">
                      <img v-else-if="item.fileType === 'pdf'"
                           src="../../../../assets/img/pdf.jpg">
                      <img v-else-if="item.fileType === 'ppt'"
                           src="../../../../assets/img/ppt.png">
                      <img v-else-if="item.fileType === 'pptx'"
                           src="../../../../assets/img/ppt.png">
                      <img v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                           :src="item.url">
                      <img v-else
                           src="../../../../assets/img/zwtp.png"
                           alt="其他">
                      <p>{{item.fileName}}</p>
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
          </el-row>
          <h3 class="spareInfo">备件需求信息</h3>
          <el-row class="two-btns">
            <el-button type="primary"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8"
                       @click="addNew()">手工增行</el-button>
            <el-button type="primary"
                       style="background:#1D65A8;color:#fff;border-color:#1D65A8"
                       @click="importInfo()">备件信息上传</el-button>
            <input type="file"
                   class="info-but but-file"
                   ref="inputer"
                   v-show="false"
                   @change="importf()"
                   accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            <el-upload v-show="false"
                       ref="fielUplod"
                       :on-success="fileSuccess"
                       :on-error="fileError"
                       accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       :headers="headerMsg"
                       :action="upLoadUrl">
              <el-button type="primary">上传文件</el-button>
            </el-upload>
            <span class="downloadTem"
                  @click="downloadTemplate()">上传模板下载</span>
          </el-row>
          <el-row>
            <el-table :data="dataList"
                      border
                      v-loading="dataListLoading"
                      @selection-change="selectionChangeHandle"
                      style="width: 100%;">
              <el-table-column prop="oldGoodsCode"
                               header-align="center"
                               align="center"
                               label="物品编码">
                <template slot-scope="scope">
                  <!-- <el-input placeholder="请输入物品编码(不超过20字..)" maxlength="20" v-model="scope.row.oldGoodsCode" @input="(e) => searchOldInfo(e, scope)"></el-input> -->
                  <el-autocomplete :minlength="2"
                                   v-model="scope.row.oldGoodsCode"
                                   :fetch-suggestions="querySearchAsync"
                                   placeholder="请输入内容"
                                   @input="(e) => handleChange(e, scope, scope.$index)"
                                   @select="handleSelect($event, scope.$index)"
                                   style="width:auto !important"
                                   popper-class="my-kqoption"
                                   :maxlength="20"></el-autocomplete>
                </template>
              </el-table-column>
              <el-table-column prop="oldGoodsName"
                               header-align="center"
                               align="center"
                               label="物品名称">
                <template slot-scope="scope">
                  <el-input placeholder="请输入物品名称(不超过50字..)"
                            maxlength="50"
                            v-model="scope.row.oldGoodsName"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="oldSpecification"
                               header-align="center"
                               align="center"
                               label="规格">
                <template slot-scope="scope">
                  <el-input placeholder="请输入规格(不超过200字..)"
                            maxlength="200"
                            v-model="scope.row.oldSpecification"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="oldModel"
                               header-align="center"
                               align="center"
                               label="型号">
                <template slot-scope="scope">
                  <el-input placeholder="请输入型号(不超过200字..)"
                            maxlength="200"
                            v-model="scope.row.oldModel"></el-input>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="oldConfiguration"
                               header-align="center"
                               align="center"
                               label="配置">
                <template slot-scope="scope">
                  <el-input placeholder="请输入配置(不超过200字..)"
                            maxlength="200"
                            v-model="scope.row.oldConfiguration"></el-input>
                </template>
              </el-table-column> -->
              <!-- <el-table-column prop="oldEdition"
                               header-align="center"
                               align="center"
                               label="版本">
                <template slot-scope="scope">
                  <el-input placeholder="请输入版本(不超过20字..)"
                            maxlength="20"
                            v-model="scope.row.oldEdition"></el-input>
                </template>
              </el-table-column> -->
              <el-table-column prop="oldBrand"
                               header-align="center"
                               align="center"
                               label="品牌">
                <template slot-scope="scope">
                  <el-input placeholder="请输入品牌(不超过200字..)"
                            maxlength="200"
                            v-model="scope.row.oldBrand"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="oldRemark"
                               header-align="center"
                               align="center"
                               label="备注">
                <template slot-scope="scope">
                  <el-input placeholder="请输入备注(不超过300字..)"
                            maxlength="300"
                            v-model="scope.row.oldRemark"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="safetyStockQuantityBef"
                               header-align="center"
                               align="right"
                               label="已申请备件量"
                               width="150">
              </el-table-column>
              <el-table-column prop="safetyStockQuantity"
                               header-align="center"
                               align="center"
                               label="备件数量"
                               :render-header="renderHeaderNew">
                <template slot-scope="scope">
                  <el-input placeholder="请输入备件数量(最长7位..)"
                            maxlength="7"
                            v-model="scope.row.safetyStockQuantity"></el-input>
                </template>
              </el-table-column>
              <el-table-column fixed="right"
                               header-align="center"
                               align="center"
                               label="操作"
                               width="80">
                <template slot-scope="scope">
                  <el-button type="text"
                             size="small"
                             @click="deleteHandle(scope.row,scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row class="remark">
            <el-col :span="24">
              <el-form-item label="备注："
                            prop="userMobile">
                <label>
                  <el-input type="textarea"
                            placeholder="请输入备注(不超过200字)..."
                            maxlength="200"
                            v-model="dataForm.remarks"
                            style="width:900px !important;"
                            :rows="3"></el-input>
                </label>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px"
               v-if="detailInfo.status !== '2'">
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="margin-right:10px;"
                 @click="routerHandle('spareRequirementsList')">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              取消
            </div>
            <div :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确定
            </div>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
export default {
  data () {
    return {
      importVisible: false, // 导入弹框
      upLoadUrl: `${window.SITE_CONFIG['apiURL']}/lclb/demand/importSpareParts`,
      errorContent: '',
      headerMsg: {
        token: getAccessToken()
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() < Date.now() + 3600 * 1000 * 24 * 6
        }
      },
      dataForm: {
        applyUser: '',
        customerName: '',
        customerLeaderName: '',
        customerLeaderMobile: '',
        wishEndDate: '',
        remarks: '',
        goodsCode: ''
      },
      goodsList: [],
      searchVisible: false,
      addForm: {
        goodsCode: '',
        goodsName: '',
        specification: '',
        model: '',
        remark: '',
        safetyStockQuantity: ''
      },
      newList: [],
      currentIndex: '',
      update: false,
      userInfo: null,
      gogo: true,
      visible: false,
      dataList: [],
      dataListLoading: false,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      detailInfo: null,
      activeIndex: 0,
      steps: [
        {
          ind: 1,
          key: '',
          name: '待受理',
          time: ''
        },
        {
          ind: 2,
          key: '',
          name: '待确认',
          time: ''
        },
        // {
        //   ind: 3,
        //   key: '',
        //   name: '备件中',
        //   time: ''
        // },
        {
          ind: 4,
          key: '',
          name: '已完成',
          time: ''
        },
        {
          ind: 5,
          key: '',
          name: '完成评价',
          time: ''
        }
      ],
      fileListS: [],
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      imgList: [],
      dataRule: {
        agreement: [
          { required: true, message: '备件需求协议不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    renderHeaderNew (cerateElement, { column }) {
      return cerateElement('div', [
        cerateElement('span', column.label),
        cerateElement(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: this.$t('message.finalQuantity'),
              placement: 'top'
            }
          },
          [
            cerateElement('i', {
              class: 'el-icon-info',
              style: 'color: #e6a23cmargin-left:2px'
            })
          ]
        )
      ])
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        // if (name === 'spareRequirementsList'){
        //    this.$router.push({name:'spareRequirementsList'})
        // } else {
        this.$router.push({ name: name })
        // }
      } else {
        this.formatFormData()
        this.$router.go(-1)
      }
    },
    // 模板下载
    downloadTemplate () {
      window.location.href = `${window.SITE_CONFIG['apiURL']}/help/consumer/templatedownload/importReceives?token=${getAccessToken()}`
    },
    // 获取信息
    getInfo () {
      this.dataListLoading = true
      this.$http
        .get(
          `/front/order/lclb/demand/info/${this.$route.query.id}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data
            this.dataForm.wishEndDate = res.data.wishEndDate
            this.dataForm.remarks = res.data.remarks
            this.dataList = res.data.demandDetailList
            if (res.data.ossFile) {
              this.fileListS = res.data.ossFile.map((item) => {
                return {
                  name: item.fileName,
                  percentage: 100,
                  status: 'success',
                  uid: '',
                  url: item.objectName,
                  ossId: item.aliOssId
                }
              })
              this.imgList = res.data.ossFile
            }
            if (res.data.applyTime) {
              this.steps[0].time = res.data.applyTime
            }
            if (res.data.acceptDate) {
              this.steps[1].time = res.data.acceptDate
            }
            if (res.data.confirmDate) {
              this.steps[2].time = res.data.confirmDate
            }
            if (res.data.finishDate) {
              this.steps[3].time = res.data.finishDate
            }
            if (res.data.signDate) {
              this.steps[4].time = res.data.signDate
            }
          }
          this.dataListLoading = false
        })
    },
    handleChange (ind, a, index) {
      // this.dataList[index].oldConfiguration = ''
      // this.dataList[index].oldEdition = ''
      this.dataList[index].spuId = ''
      this.dataList[index].skuId = ''
      this.dataList[index].oldGoodsName = ''
      this.dataList[index].oldModel = ''
      this.dataList[index].oldRemark = ''
      this.dataList[index].oldSpecification = ''
      this.dataList[index].oldBrand = ''
      this.dataList[index].safetyStockQuantityBef = ''
      this.dataList[index].safetyStockQuantity = ''
    },
    querySearchAsync (queryString, cb) {
      var array = []
      if (queryString && queryString.length > 1) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: queryString,
          companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
        }
        this.$http.post(`/front/order/lclb/demand/getStockBefByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                res.data.forEach(item => {
                  item.value = item.codeSpeciModel
                })
                cb(res.data)
              } else {
                cb(array)
              }
            } else {
              cb(array)
            }
          })
      }
    },
    handleSelect (item, index) {
      // this.dataList[index].oldConfiguration = item.oldConfiguration
      // this.dataList[index].oldEdition = item.oldEdition
      this.dataList[index].spuId = item.spuId
      this.dataList[index].skuId = item.skuId
      this.dataList[index].oldGoodsCode = item.oldGoodsCode
      this.dataList[index].oldGoodsName = item.oldGoodsName
      this.dataList[index].oldModel = item.oldModel
      this.dataList[index].oldRemark = item.oldRemark
      this.dataList[index].oldSpecification = item.oldSpecification
      this.dataList[index].oldBrand = item.oldBrand
      this.dataList[index].safetyStockQuantityBef = item.safetyStockQuantityBef
    },
    // 手工增行
    addNew () {
      this.dataList.push({
        spuId: '',
        skuId: '',
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        // oldConfiguration: '',
        // oldEdition: '',
        oldBrand: '',
        safetyStockQuantity: ''
      })
    },
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      this.subLoading = true
    },
    // 当前商品编码的商品原信息
    searchOldInfo (goodCode, scope) {
      scope.row.safetyStockQuantityBef = 0
      this.dataList[scope.$index].safetyStockQuantityBef = 0
      if (goodCode) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: goodCode,
          companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
        }
        this.$http.post(`/front/order/lclb/demand/getStockBefByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.dataList[scope.$index].safetyStockQuantityBef =
                res.data.safetyStockQuantityBef || 0
              scope.row.safetyStockQuantityBef =
                res.data.safetyStockQuantityBef || 0
            }
          })
          .catch(() => {
            // this.dataList[scope.$index].safetyStockQuantityBef = 10
            // scope.row.safetyStockQuantityBef = 10
          })
          .finally(() => {
            this.$set(this.dataList, scope.$index, scope.row)
          })
      }
    },
    // 备件信息上传
    importInfo () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导入成功
    fileSuccess (response) {
      if (response.code === 0) {
        this.$message.success(response.message || '导入成功')
        var totalList = [...this.dataList, ...response.data]
        this.dataList = totalList
      } else {
        this.errorContent = response.info || ''
        this.importVisible = true
      }
    },
    // 导入失败
    fileError (file, fileList) {
      this.$message.error('导入失败，请重新上传')
    },
    deleteHandle (row, index) {
      this.newList.splice(index, 1)
      this.dataList.splice(index, 1)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 确认
    handleSave () {
      if (this.subLoading) {
        return false
      }
      var flag = true
      if (this.dataList.length === 0) {
        this.$message.warning('请填写物品编码后进行添加')
        flag = false
      }
      //  if (this.fileListS.length === 0){
      //   this.$message.error('请上传备件需求协议')
      //   flag = false
      // }
      this.dataList.forEach((item) => {
        if (item.oldGoodsCode === '') {
          this.$message.warning('请填写物品编码后进行维护')
          flag = false
        }
        // let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
        // if (regx.test(item.oldGoodsCode)) {
        // } else {
        //   this.$message.warning('物品编码不能有空格 + 《 》等特殊符号')
        //   flag = false
        // }
        if (item.oldGoodsName === '') {
          this.$message.warning('请填写备件名称后进行维护')
          flag = false
        }
        if (item.safetyStockQuantity === '') {
          this.$message.warning('请填写备件数量后进行维护')
          flag = false
        }
        if (!new RegExp('^[1-9]([0-9])*$').test(item.safetyStockQuantity)) {
          this.$message.warning('备件数量只能为大于0的正整数且不能超过7位数')
          flag = false
        }
      })
      var newList = []
      this.dataList.forEach((item) => {
        const {
          spuId,
          skuId,
          oldGoodsCode,
          oldGoodsName,
          oldSpecification,
          oldModel,
          oldRemark,
          safetyStockQuantity,
          // oldConfiguration,
          // oldEdition,
          oldBrand
        } = item
        newList.push({
          spuId,
          skuId,
          oldGoodsCode,
          oldGoodsName,
          oldSpecification,
          oldModel,
          oldRemark,
          safetyStockQuantity,
          // oldConfiguration,
          // oldEdition,
          oldBrand
        })
      })
      let agreementList = this.fileListS.map((item) => {
        return { aliOssId: item.ossId }
      })
      if (flag) {
        this.subLoading = true
        this.$http
          .post(
            `/front/order/lclb/demand/updateByOrdinary`,
            {
              demandId: this.$route.query.id,
              wishEndDate: this.dataForm.wishEndDate,
              remarks: this.dataForm.remarks,
              demandDetailList: newList,
              ossRelation: agreementList
            }
          )
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('维护成功')
              this.subLoading = false
              this.$router.push({ name: 'spareRequirementsList' })
            } else {
              this.subLoading = false
            }
          })
          .catch(() => {
            this.subLoading = false
          })
      }
    },
    // 上传备件需求协议
    // 上传附件
    handleRemove (file, fileList) {
      // console.log(file, fileList)
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId && file.save) {
        let index = this.fileListS.findIndex((item) => {
          return item.ossId === file.ossId
        })
        if (index > -1) {
          this.delUrls.push(this.fileListS[index].ossId)
          this.fileListS.splice(index, 1)
        }
      } else if (file.uid) {
        let index = this.fileListS.findIndex((item) => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http
            .post(
              `help/fileupload/sys/deleteBatchAliOss`, [this.fileListS[index].ossId]
            )
            .then(() => {
              this.fileListS.splice(index, 1)
              this.imgList.splice(index, 1)
            })
            .catch(() => { })
        }
      }
    },
    // 上传成功
    successFile (response) {
      if (response.code === 0) {
        let ossId = response.data.aliOssId
        let filename = response.data.fileName
        let fileType = response.data.fileType
        let url = response.data.url
        let objNew = {
          createDate: null,
          fileName: filename,
          fileSize: '',
          fileType: fileType,
          id: ossId,
          objectName: url,
          status: false,
          svgName: '',
          type: ''
        }
        this.fileListS.push({
          // uid: file.uid,
          ossId: ossId,
          ossName: url,
          name: filename
          // uploadId: checkpoint.uploadId
        })
        this.imgList.push(objNew)
        this.subLoading = false
      } else {
        this.subLoading = false
        this.$message.error(response.message)
      }
    },
    // 上传失败
    errorFile (file, fileList) {
      this.subLoading = false
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      )
    },
    removeHandle (file, index) {
      this.$http
        .post(
          `help/fileupload/sys/deleteBatchAliOss`, [file.aliOssId]
        )
        .then(() => {
          this.fileListS.splice(index, 1)
          this.imgList.splice(index, 1)
        })
        .catch(() => { })
    },
    // 下载文档
    download (item) {
      var a = document.createElement('a')
      a.href = item
      a.setAttribute('href', a.href)
      a.setAttribute('target', '_blank')
      a.click()
      // document.body.removeChild(a)
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.two-btns {
  margin-bottom: 10px;
}
.btns {
  margin-left: 230px;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.btn-check {
  margin-right: 30px;
}
.downloadTem {
  margin-left: 20px;
  color: #1d65a8;
}
.downloadTem:hover {
  cursor: pointer;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.sjz {
  display: flex;
  justify-content: center;
  line-height: 40px;
  padding: 20px 70px;
  background-color: #fff;
}
.sjz-kuaikuai {
  display: flex;
  flex: 1;
}
.sjz-line {
  margin-top: 30px;
  flex: 1;
}
.sjz-item {
  width: 70px;
}
.sjz-icon {
  background: #ffffff;
  border: 1px solid #1d65a8;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 10px;
  margin-left: 15px;
  line-height: 38px;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
}
.sjz-icon .sjc-num {
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
}
.sjz-undone {
  color: #cacaca;
  border: 1px solid #cacaca;
}
.sjz-do {
  background-color: #1d65a8;
  color: #fff;
}
.sjz-icon .el-icon-check {
  font-size: 30px;
  line-height: 38px;
  font-weight: 900;
  color: #1d65a8;
}
.sjz-word {
  /* padding-left: 10px; */
  color: #1d65a8;
  text-align: center;
  width: 100%;
  line-height: 30px;
}
.sjz-time {
  color: #1d65a8;
  text-align: left;
  width: 130px;
  line-height: 20px;
  text-indent: -22px;
}
.sjz-line {
  height: 2px;
  background: #1d65a8;
  width: 20px;
}
// 上传
.inquiryfj {
  padding-left: 160px;
}
.inquiryfj li {
  width: 600px;
  height: 50px;
  position: relative;
  cursor: pointer;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 40px;
  height: 40px;
  float: left;
}
.inquiryfj li p {
  text-align: left;
  font-size: 14px;
  line-height: 40px;
  color: #333333;
  font-weight: bold;
  width: 450px;
  height: 40px;
  text-indent: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
  white-space: nowrap;
}
.inquiryfj li i {
  font-size: 95px;
  cursor: pointer;
}
.removePic {
  right: -16px;
  top: 0px;
  cursor: pointer;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.remark {
  margin-top: 30px;
}
.row-height {
  height: 24px;
}
.row-margin {
  margin-bottom: 12px;
}
.row-date {
  height: 36px;
}
</style>
